/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionListEntry } from './PalReauthSubmissionListEntry';
import {
    PalReauthSubmissionListEntryFromJSON,
    PalReauthSubmissionListEntryFromJSONTyped,
    PalReauthSubmissionListEntryToJSON,
    PalReauthSubmissionListEntryToJSONTyped,
} from './PalReauthSubmissionListEntry';

/**
 * 
 * @export
 * @interface GetLatestPalReauthSubmission200Response
 */
export interface GetLatestPalReauthSubmission200Response {
    /**
     * 
     */
    data?: PalReauthSubmissionListEntry;
}

/**
 * Check if a given object implements the GetLatestPalReauthSubmission200Response interface.
 */
export function instanceOfGetLatestPalReauthSubmission200Response(value: object): value is GetLatestPalReauthSubmission200Response {
    return true;
}

export function GetLatestPalReauthSubmission200ResponseFromJSON(json: any): GetLatestPalReauthSubmission200Response {
    return GetLatestPalReauthSubmission200ResponseFromJSONTyped(json, false);
}

export function GetLatestPalReauthSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLatestPalReauthSubmission200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionListEntryFromJSON(json['data']),
    };
}

export function GetLatestPalReauthSubmission200ResponseToJSON(json: any): GetLatestPalReauthSubmission200Response {
    return GetLatestPalReauthSubmission200ResponseToJSONTyped(json, false);
}

export function GetLatestPalReauthSubmission200ResponseToJSONTyped(value?: GetLatestPalReauthSubmission200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionListEntryToJSON(value['data']),
    };
}

